import React, { useState, useRef } from 'react';
import { Avatar, notification } from 'antd';

import { Modal } from '_src/components';

import { ProfileImage, VideoContainer, ImageContainer, DeleteButton, Container } from './styles';

export default ({
  value,
  onChange,
  editable = false,
  fixed = true,
  showDelete = false,
  onDelete = () => {}
}) => {
  const [isCameraShown, setCameraVisibility] = useState(false);
  const [isDeletePictureShown, showDeletePictureModal] = useState(false);

  const videoRef = useRef(null);
  const [videoStream, setVideoStream] = useState();

  const openCamera = async () => {
    if (editable) {
      setCameraVisibility(true);
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: 'environment' }
          });

          if (!videoRef.current) {
            stream.getTracks().forEach(track => track.stop());
            return;
          }

          videoRef.current.srcObject = stream;
          videoRef.current.play();
          setVideoStream(stream);
        } catch {
          setCameraVisibility(false);
          notification.error({ message: 'Camera access is unavailable' });
        }
      } else {
        setCameraVisibility(false);
        notification.error({ message: 'Camera access is unavailable' });
      }
    }
  };

  const takePhoto = () => {
    const video = videoRef.current;

    if (!video || !videoStream) {
      notification.error({ message: 'Camera is not ready' });
      return;
    }

    const canvas = document.createElement('canvas');

    canvas.width = video.width;
    canvas.height = video.height;

    document.querySelector('body').appendChild(canvas);

    canvas.getContext('2d').drawImage(video, 0, 0, video.width, video.height);
    const snapshot = canvas.toDataURL('image/png');
    canvas.parentNode.removeChild(canvas);

    video.pause();
    video.src = '';
    videoStream.getTracks().forEach(track => track.stop());
    setVideoStream(undefined);
    setCameraVisibility(false);
    onChange(snapshot);
  };

  const cleanUp = () => {
    if (videoStream) {
      videoStream.getTracks().forEach(track => track.stop());
    }
    setCameraVisibility(false);
  };

  const deletePicture = () => {
    showDeletePictureModal(false);
    onDelete();
  };

  return (
    <div>
      <Container>
        {value && showDelete && (
          <DeleteButton
            type="button"
            aria-label="Delete student profile picture"
            onClick={() => showDeletePictureModal(true)}
          />
        )}
        <Modal
          visible={isDeletePictureShown}
          title="Delete student profile picture"
          onCancel={() => showDeletePictureModal(false)}
          okText="Delete picture"
          onOk={deletePicture}
          style={{ display: 'flex' }}
        >
          Are you sure you want to remove this photo?
        </Modal>
      </Container>
      <ImageContainer
        type="button"
        onClick={openCamera}
        fixed={fixed}
        disabled={!editable}
        aria-label={editable ? 'Change student profile picture' : 'Student profile picture'}
      >
        {value && <ProfileImage src={value} alt="Student profile" />}
        {!value && <Avatar size={80} icon="user" />}
      </ImageContainer>

      <VideoContainer>
        <Modal
          visible={isCameraShown}
          title="Change student profile picture"
          onCancel={cleanUp}
          okText="Take picture"
          onOk={takePhoto}
          style={{ display: 'flex' }}
        >
          <VideoContainer>
            <video ref={videoRef} width="400" height="300" autoPlay aria-label="Camera preview" />
          </VideoContainer>
        </Modal>
      </VideoContainer>
    </div>
  );
};
